import React, { useState } from 'react'
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess } from '../utils/permissions';
import T from '../components/Translation';
import { dT } from '../components/Translation';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import { useQuery } from '@tanstack/react-query';
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { _FETCH, _FETCH_POST } from '../utils/patches';
import { SongPin } from './ManageSongs';
import FieldDropdown from '../whitaijiFrontendLibrary/components/FieldDropdown';  


const LogsReport = () => {

const {user} = useAuthContext(AuthContext)
const {hideTestButtons, language, apiUrl} = useStateContext()
const [selectedUser, setSelectedUser] = useState()

const { data: songsData={},  isLoading: isLoadingSongsData } = useQuery({
    queryKey: ['songs'],
    enabled: !!user && !!apiUrl,
    queryFn: async () => {
        const songs = await _FETCH({
        route: `${apiUrl}/songs`,
        user
        });
        return songs;
    }
});
const { data: songLogsData={},  isLoading: isLoadingSongLogsData } = useQuery({
    queryKey: ['songLogs'],
    enabled: !!user && !!apiUrl,
    queryFn: async () => {
        const songLogs = await _FETCH({
        route: `${apiUrl}/song-logs/all`,
        user
        });
        return songLogs;
    }
});
const { data: users={},  isLoading: isLoadingUsers } = useQuery({
    queryKey: ['users'],
    enabled: !!user && !!apiUrl,
    queryFn: async () => {
        const users = await _FETCH_POST({
        route: `${apiUrl}/user/all-user-profiles`,
        body: { userIsGodMode: user?.userType === "godMode" ? true : false },
        user
        });
        return users;
    }
});
const userLabel = (x) => {
  if(x?.firstName && x?.lastName) {return `${x?.firstName} ${x?.lastName}`}
  return x?.email
}
const userOptions = !Array.isArray(users) ? [] : users?.map((x) => ({label: userLabel(x), value: x?._id}))

const { data: concertLogData={},  isLoading: isLoadingConcertLogData } = useQuery({
    queryKey: ['concertLogs'],
    enabled: !!apiUrl,
    queryFn: async () => {
        const concertLogs = await _FETCH({
        route: `${apiUrl}/concert-logs/`,
        user,
        //onSuccess: () => {console.log("concertLogData", concertLogData)}
        });
        return concertLogs;
    }
});

  const songLogs = !Array.isArray(songLogsData) ? [] : songLogsData?.filter((x) => selectedUser ? x?.user_id === selectedUser : x)
   const songSourceWithInterlude = !Array.isArray(songsData) ? [] : songsData?.filter((x) => x?.isWithPrelude)
   const songSourceWithoutInterlude =  !Array.isArray(songsData) ? [] : songsData?.filter((x) => !x?.isWithPrelude)
const testFunction = () => {
  process.env.NODE_ENV === "development" && console.log("TEST", {concertLogData, users , songsData, songLogsData}) 
}

if (!isGodMode(user)) {
    return <NoAccess />
}
  return (
    <div style={{margin: "20px"}}>
    <BlueButton fn={testFunction} hide={hideTestButtons} />
    <FieldDropdown
      options={userOptions}
      onChange={(e) => setSelectedUser(e?.value)}
      //value={selectedUser}
      placeHolder={<T obj={{en: "Select User", it: "Seleziona utente"}} />}
    />
    <h3 style={{margin: "20px 0px 20px 0px"}}>
        {<T obj={{en: "Total Song Logs", it: "Logs Totali"}} />}
        <p>{songLogs?.length}</p>
        
    </h3>
    {songSourceWithoutInterlude?.map((item, index) => <SongPin hideEdit={true} songLogs={songLogs?.filter((x) => x?.songId === item?._id)} key={index} data={{songItem: item}} />)}

    <VisDiv rules={[songSourceWithInterlude?.length > 0]}>
        <h3 style={{margin: "20px 0px 20px 0px"}}>
            {<T obj={{en: "Songs With Interlude", it: "Canzoni con interludio"}} />}
        </h3>
        {songSourceWithInterlude?.map((item, index) => <SongPin key={index} songLogs={songLogs?.filter((x) => x?.songId === item?._id)} hideEdit={true} data={{songItem: item}} />)}
    </VisDiv>
    
    </div>
  )
}

export default LogsReport

